import { MetricPanel } from "./AnalyticsVisuals";
import { Inventory2Outlined } from "@mui/icons-material";

import { InventoryAnalytics as InventoryAnalyticsType } from "../types";

interface InventoryAnalyticsProps {
  data?: InventoryAnalyticsType | null;
}

const InventoryAnalytics = ({ data }: InventoryAnalyticsProps) => {
  const rows = [
    ["Total Stock", data?.totalStock ?? 0],
    ["Available Stock", data?.availableStock ?? 0],
    ["Reserved Stock", data?.reservedStock ?? 0],
    ["Damaged Stock", data?.damagedStock ?? 0],
    ["Inventory Value", `Rs ${data?.inventoryValue?.toLocaleString() ?? 0}`],
    ["Warehouses", data?.warehouseWise?.length ?? 0],
  ];

  return <MetricPanel title="Inventory Analytics" rows={rows} icon={<Inventory2Outlined />} />;
};

export default InventoryAnalytics;
